import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { Typography, TextField } from "@material-ui/core";
import SectionSeparator from "../../Recap/SectionSeparator";
import Input from "@material-ui/core/Input";

import Colors from "../../../constants/Colors";

const styles = theme => ({
  main: {
    // marginTop: 15,
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    display: "flex"
  },
  paper: {
    marginTop: 15,
    position: "relative",
    overflow: "hidden",
    width: "47%",
    // flex: 1,
    // height: 80,
    borderRadius: 80,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "center",
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8"
  },
  root: {
    width: "100%",
    minWidth: 150,
    height: 250,
    backgroundColor: theme.palette.background.paper
  },
  bold: {
    fontWeight: 500,
    marginBottom: 10
  },
  box: {
    width: "100%",
    borderBottom: "1px solid transparent",
    borderTop: "1px solid transparent",
    borderColor: "#E1E6E8",
    flex: 1,
    flexDirection: "row",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    transition: "box-shadow 100ms ease-in-out",
    "&:hover": {
      backgroundColor: Colors.lightGrey
    },
    cursor: "pointer"
  },
  quote: {
    width: "100%",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    color: Colors.text,
    letterSpacing: "0.0075em",
    alignItems: "center",
    justifyContent: "flex-start",
    display: "flex"
  },
  sign: {
    alignItems: "center",
    MozBoxSizing: "border-box",
    boxSizing: "border-box",
    display: "inline-flex",
    height: "25px",
    justifyContent: "center",
    width: "25px",
    background: "#fff",
    border: "1px solid #b7bfc6",
    borderRadius: "50%",
    color: "#848f99",
    fill: "#848f99",
    // color: "#b7bfc6",
    transition:
      "200ms box-shadow,200ms color,200ms background,200ms fill,200ms border-color",
    margin: "0 10px 0 0",
    "&:hover": {
      backgroundColor: "#e2fffa",
      borderColor: "#25e8c8",
      color: "#25e8c8",
      fill: "#25e8c8",
      cursor: "pointer"
    }
  },
  signSelected: {
    backgroundColor: "#e2fffa",
    borderColor: "#25e8c8",
    color: "#25e8c8",
    fill: "#25e8c8",
    cursor: "pointer"
  },
  questionSelected: {
    backgroundColor: "#EDF8FF",
    // borderColor: "#25e8c8",
    borderWidth: 1,
    "&:hover": {
      backgroundColor: "#EDF8FF"
    }
  },
  divSelected: {},
  signNumber: {},
  rightSection: {
    display: "flex",
    flex: 1
  },
  title: {
    // color: "#788593"
  },
  separator: {
    width: "100%",
    height: 1,
    backgroundColor: "black"
    // backgroundColor: "#E8F3FD"
    // backgroundColor: "#fff"
  },
  titleSeparator: {
    width: "100%",
    marginBottom: 5,
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    display: "flex"
  },
  noTopBorder: {
    borderTopWidth: 0
  },
  underline: {
    borderColor: "#ffd54e",
    "&:after": {
      // The MUI source seems to use this but it doesn't work
      borderBottom: "2px solid #ffd54e"
    }
  }
});

const QuestionBlock = ({
  classes,
  text,
  number,
  noTopBorder,
  onClick,
  isSelected,
  inputValue,
  onChangeText
}) => {
  return (
    <div className={`${classes.main} ${isSelected && classes.divSelected}`}>
      <div
        className={`${classes.box} ${noTopBorder &&
          classes.noTopBorder} ${isSelected && classes.questionSelected}`}
        onClick={onClick}
      >
        <div
          className={`${classes.sign} ${isSelected && classes.signSelected}`}
        >
          <p className={classes.signNumber}>{number}</p>
        </div>
        <p className={classes.quote}>{text}</p>
      </div>
      {isSelected && (
        <TextField
          value={inputValue}
          onChange={onChangeText}
          fullWidth
          autoFocus
          multiline
          variant="outlined"
          placeholder="Écrire mes notes"
          classes={{ root: classes.underline }}
          inputProps={{
            "aria-label": "Description"
          }}
        />
      )}
    </div>
  );
};

QuestionBlock.defaultProps = {
  noTopBorder: false
};

export default withStyles(styles)(QuestionBlock);
